import { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function Login() {

  const [role, setRole] = useState("User");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "http://localhost/autohelper-api/login.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            email,
            password,
            role
          })
        }
      );

      const data = await response.json();

      if (data.status === "success") {

        alert("Login Successful ✅");

        if (role === "Admin") {
          navigate("/admin-dashboard");
        } else if (role === "Helper") {
          navigate("/helper-dashboard");
        } else {
          navigate("/user-dashboard");
        }

      } else {
        alert("Invalid Credentials ❌");
      }

    } catch (error) {
      alert("Server Error ⚠");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-indigo-100 px-4">

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="backdrop-blur-lg bg-white/70 border border-white/40 shadow-2xl p-10 rounded-3xl w-full max-w-md relative overflow-hidden"
      >

        <h2 className="text-3xl font-extrabold text-center mb-8 bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
          Login to AutoHelper AI
        </h2>

        {/* Role Selection */}
        <div className="flex justify-between mb-6">
          {["User", "Helper", "Admin"].map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setRole(item)}
              className={`px-5 py-2 rounded-full transition-all duration-300 font-medium
                ${
                  role === item
                    ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg scale-105"
                    : "bg-gray-200 text-gray-700 hover:bg-blue-100"
                }`}
            >
              {item}
            </button>
          ))}
        </div>

        {/* Email */}
        <input
          type="email"
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-3 rounded-xl border border-gray-300 mb-5 focus:ring-2 focus:ring-blue-500 outline-none"
        />

        {/* Password */}
        <input
          type="password"
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-3 rounded-xl border border-gray-300 mb-8 focus:ring-2 focus:ring-blue-500 outline-none"
        />

        {/* Login Button */}
        <button
          onClick={handleLogin}
          className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-xl font-semibold hover:scale-105 transition"
        >
          Login as {role}
        </button>

      </motion.div>
    </div>
  );
}
